import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase/firebase-config';
import { nameInArroba, getLadaPorZona } from '../../helpers/util';
import Swal from 'sweetalert2';

const DIAS_LABELS = { lunes: 'Lunes', martes: 'Martes', miercoles: 'Miércoles', jueves: 'Jueves', viernes: 'Viernes', sabado: 'Sábado', domingo: 'Domingo' };
const DIAS_DEFAULT = [
    { id: 'lunes', label: 'Lunes', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'martes', label: 'Martes', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'miercoles', label: 'Miércoles', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'jueves', label: 'Jueves', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'viernes', label: 'Viernes', activo: true, entrada: '10:00', salida: '20:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'sabado', label: 'Sábado', activo: true, entrada: '10:00', salida: '18:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
    { id: 'domingo', label: 'Domingo', activo: false, entrada: '10:00', salida: '18:00', tieneComida: false, ini_comida: '13:00', fin_comida: '14:00' },
];

const jornadaADias = (jornada) => {
    const diasActivos = (jornada || []).map(d => d.id);
    return DIAS_DEFAULT.map(d => ({
        ...d,
        activo: diasActivos.includes(d.id),
        ...(jornada?.find(j => j.id === d.id) || {}),
        label: DIAS_LABELS[d.id] || d.id,
        tieneComida: jornada?.find(j => j.id === d.id)?.ini_comida !== '00:00' && !!jornada?.find(j => j.id === d.id)?.ini_comida,
    }));
};

// ── Formulario de colaboradora ────────────────────────────────────────────────
const FormColaboradora = ({ colaboradora, onChange, onGuardar, onCancelar, ladaPais, zonaHoraria, hashtag, esPrimera, catalogo, categorias, serviciosAsignados, onToggleServicio, onToggleGrupo, hayOtraDuena, yaConectoCalendario }) => {
    const SERVICE_ACCOUNT = 'revi-calendar-bot@revi-recepcionista-virtual.iam.gserviceaccount.com';
    const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const SCOPE = 'https://www.googleapis.com/auth/calendar openid email profile';

    const bandera = ladaPais === '521' ? '🇲🇽' : ladaPais === '57' ? '🇨🇴' : '🌎';

    const abrirOAuthPopup = async (callback) => {
        if (!yaConectoCalendario) {
            const { isConfirmed } = await Swal.fire({
                title: 'Importante: marca el permiso ✅',
                html: 'En la siguiente pantalla de Google, asegúrate de <b>marcar ✅ el checkbox</b> que aparece para autorizar el acceso al calendario.<br/><br/>Sin ese permiso, <b>no podremos agendar las citas correctamente</b>.',
                imageUrl: '/img/explicar_calendar.png',
                imageAlt: 'Marcar checkbox de permisos de Google Calendar',
                imageWidth: 280,
                confirmButtonText: 'Entendido, continuar',
                confirmButtonColor: '#D4537E',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
            });
            if (!isConfirmed) return;
        }

        const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(window.location.origin + '/app')}&response_type=token&scope=${encodeURIComponent(SCOPE)}&prompt=select_account`;
        const popup = window.open(url, 'google-oauth', 'width=500,height=600,left=200,top=100');
        const poll = setInterval(() => {
            try {
                if (!popup || popup.closed) { clearInterval(poll); return; }
                const hash = popup.location.hash;
                if (hash && hash.includes('access_token')) {
                    const params = new URLSearchParams(hash.substring(1));
                    const token = params.get('access_token');
                    if (token) { clearInterval(poll); popup.close(); callback(token); }
                }
            } catch (e) {}
        }, 500);
    };

    const conectarCalendarioPersonal = () => {
        if (!colaboradora.nombre.trim()) { Swal.fire('Falta el nombre', 'Ingresa primero el nombre.', 'warning'); return; }
        abrirOAuthPopup(async (token) => {
            try {
                const userInfo = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json());
                await fetch('https://www.googleapis.com/calendar/v3/calendars/primary/acl', {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ role: 'writer', scope: { type: 'user', value: SERVICE_ACCOUNT } })
                });
                // Actualizar zona horaria del calendario personal
                // Actualizar zona horaria del calendario personal
                await fetch(`https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(userInfo.email)}`, {
                    method: 'PATCH',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ timeZone: zonaHoraria || 'America/Mexico_City' })
                });
                onChange({ ...colaboradora, idCalendar: userInfo.email, esDuena: true });
                Swal.fire('¡Listo!', `Calendario de ${userInfo.email} conectado.`, 'success');
            } catch (e) { Swal.fire('Error', 'No se pudo conectar el calendario.', 'error'); }
        });
    };

    const crearCalendarioSecundario = () => {
        if (!colaboradora.nombre.trim()) { Swal.fire('Falta el nombre', 'Ingresa primero el nombre.', 'warning'); return; }
        abrirOAuthPopup(async (token) => {
            try {
                const nombre = colaboradora.nombre.trim();
                const calCreado = await fetch('https://www.googleapis.com/calendar/v3/calendars', {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ summary: `Revi - ${nombre}`, timeZone: zonaHoraria || 'America/Mexico_City' }),
                }).then(r => r.json());
                if (!calCreado.id) throw new Error();
                await fetch(`https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(calCreado.id)}/acl`, {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({ role: 'writer', scope: { type: 'user', value: SERVICE_ACCOUNT } }),
                });
                onChange({ ...colaboradora, idCalendar: calCreado.id, esDuena: false });
                Swal.fire('¡Listo!', `Calendario "Revi - ${nombre}" creado correctamente.`, 'success');
            } catch (e) { Swal.fire('Error', 'No se pudo crear el calendario.', 'error'); }
        });
    };

    const toggleDia = (idx) => {
        const nuevos = colaboradora.jornada.map((d, i) =>
            i === idx ? { ...d, activo: !d.activo } : d
        );
        onChange({ ...colaboradora, jornada: nuevos });
    };

    const updateJornada = (idx, campo, valor) => {
        const nuevos = colaboradora.jornada.map((d, i) =>
            i === idx ? { ...d, [campo]: valor } : d
        );
        onChange({ ...colaboradora, jornada: nuevos });
    };

    const aplicarATodos = (entrada, salida) => {
        onChange({ ...colaboradora, jornada: colaboradora.jornada.map(d => d.activo ? { ...d, entrada, salida } : d) });
    };

    const aplicarComidaATodos = (ini_comida, fin_comida) => {
        onChange({ ...colaboradora, jornada: colaboradora.jornada.map(d => d.activo ? { ...d, tieneComida: true, ini_comida, fin_comida } : d) });
    };

    return (
        <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, marginTop: 8 }}>
            <div className="field-label" style={{ marginTop: 0 }}>Nombre</div>
            <input className="field-input" placeholder="Ej. Andrea" value={colaboradora.nombre}
                onChange={e => onChange({ ...colaboradora, nombre: e.target.value })} autoFocus />
            <p className="field-hint">Así la verán tus clientas al reservar</p>

            <div className="field-label">Teléfono de WhatsApp</div>
            <p className="field-hint" style={{ marginBottom: 6 }}>📲 Aquí le llegarán las notificaciones de nuevas citas</p>
            <div style={{ display: 'flex', gap: 8 }}>
                <div style={{ padding: '12px', border: '0.5px solid var(--border)', borderRadius: 10, fontSize: 14, color: 'var(--pink-900)', whiteSpace: 'nowrap', background: '#fff' }}>
                    {bandera} +{ladaPais}
                </div>
                <input className="field-input" style={{ flex: 1 }} placeholder="10 dígitos" type="tel" inputMode="numeric"
                    value={colaboradora.telefono} onChange={e => onChange({ ...colaboradora, telefono: e.target.value.replace(/\D/g, '').slice(0, 10) })} maxLength={10} />
            </div>

            <div className="field-label">Calendario de Google</div>
            <p className="field-hint" style={{ marginBottom: 8 }}>📅 Aquí se verán reflejadas las citas en Google Calendar</p>
            {colaboradora.idCalendar ? (
                <div className="info-box" style={{ marginTop: 0 }}>
                    <div className="info-box-title">✓ Calendario conectado {colaboradora.esDuena && '👑'}</div>
                    <div className="info-box-body" style={{ wordBreak: 'break-all', fontSize: 11 }}>{colaboradora.idCalendar}</div>
                    <button onClick={() => onChange({ ...colaboradora, idCalendar: '' })}
                        style={{ fontSize: 12, color: 'var(--pink-600)', background: 'none', border: 'none', cursor: 'pointer', marginTop: 4, textDecoration: 'underline' }}>
                        Cambiar calendario
                    </button>
                </div>
            ) : colaboradora.esDuena ? (
                // Esta colaboradora YA era la dueña — solo permitir reconectar calendario personal
                <>
                    <button className="btn-primary" style={{ fontSize: 13, marginTop: 0, width: '100%' }} onClick={conectarCalendarioPersonal}>
                        👑 Reconectar mi calendario personal
                    </button>
                    <p className="field-hint" style={{ marginTop: 8, fontSize: 11, lineHeight: 1.4 }}>
                        💡 Esta es la dueña del negocio. Su calendario es la cuenta personal de Google.
                    </p>
                </>
            ) : hayOtraDuena ? (
                // Ya hay otra dueña — solo crear calendario nuevo
                <>
                    <button className="btn-primary" style={{ fontSize: 13, marginTop: 0, width: '100%' }} onClick={crearCalendarioSecundario}>
                        📅 Crear calendario para esta colaboradora
                    </button>
                    <p className="field-hint" style={{ marginTop: 8, fontSize: 11, lineHeight: 1.4 }}>
                        💡 Se creará un calendario nuevo dentro de tu cuenta de Google (la dueña). Desde ahí podrás ver las citas de esta colaboradora.
                    </p>
                </>
            ) : (
                // No hay dueña todavía — preguntar
                <>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                        <button className="btn-primary" style={{ fontSize: 12, marginTop: 0 }} onClick={conectarCalendarioPersonal}>👑 Es para mí</button>
                        <button className="btn-outline" style={{ fontSize: 12, marginTop: 0 }} onClick={crearCalendarioSecundario}>Es para una colaboradora</button>
                    </div>
                    <p className="field-hint" style={{ marginTop: 8, fontSize: 11, lineHeight: 1.4 }}>
                        💡 <b>Es para mí:</b> conecta tu calendario personal de Google.<br/>
                        <b>Es para una colaboradora:</b> se crea un calendario nuevo dentro de tu cuenta de Google. Desde ahí podrás ver las citas de esa colaboradora.
                    </p>
                </>
            )}

            <div className="field-label" style={{ marginTop: 16 }}>Horario</div>
            {colaboradora.jornada.map((dia, idx) => (
                <div key={dia.id} className="day-row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
                        <div className="day-name">{dia.label}</div>
                        <div className={`day-toggle ${dia.activo ? 'on' : ''}`} onClick={() => toggleDia(idx)}><div className="day-toggle-thumb" /></div>
                        {dia.activo ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, flexWrap: 'wrap' }}>
                                <input className="time-input" type="time" value={dia.entrada} onChange={e => updateJornada(idx, 'entrada', e.target.value)} />
                                <span style={{ fontSize: 12, color: 'var(--pink-800)' }}>a</span>
                                <input className="time-input" type="time" value={dia.salida} onChange={e => updateJornada(idx, 'salida', e.target.value)} />
                                <button onClick={() => aplicarATodos(dia.entrada, dia.salida)}
                                    style={{ fontSize: 10, color: 'var(--pink-600)', background: 'none', border: '0.5px solid var(--pink-200)', borderRadius: 6, padding: '2px 6px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                    Aplicar a todos
                                </button>
                            </div>
                        ) : <span style={{ fontSize: 12, color: 'var(--pink-200)' }}>No trabaja</span>}
                    </div>
                    {dia.activo && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingLeft: 8, flexWrap: 'wrap' }}>
                            <div className={`day-toggle ${dia.tieneComida ? 'on' : ''}`} style={{ width: 28, height: 16, borderRadius: 8 }}
                                onClick={() => updateJornada(idx, 'tieneComida', !dia.tieneComida)}>
                                <div className="day-toggle-thumb" style={{ width: 12, height: 12, top: 2, left: dia.tieneComida ? 14 : 2 }} />
                            </div>
                            <span style={{ fontSize: 12, color: 'var(--pink-800)' }}>Hora de comida</span>
                            {dia.tieneComida && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                    <input className="time-input" type="time" value={dia.ini_comida} onChange={e => updateJornada(idx, 'ini_comida', e.target.value)} />
                                    <span style={{ fontSize: 11, color: 'var(--pink-800)' }}>a</span>
                                    <input className="time-input" type="time" value={dia.fin_comida} onChange={e => updateJornada(idx, 'fin_comida', e.target.value)} />
                                    <button onClick={() => aplicarComidaATodos(dia.ini_comida, dia.fin_comida)}
                                        style={{ fontSize: 10, color: 'var(--pink-600)', background: 'none', border: '0.5px solid var(--pink-200)', borderRadius: 6, padding: '2px 6px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                        Aplicar a todos
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}

            {catalogo && catalogo.length > 0 && (
                <>
                    <div className="field-label" style={{ marginTop: 16 }}>Servicios asignados</div>
                    <p className="field-hint" style={{ marginBottom: 8 }}>Selecciona los servicios que atiende esta colaboradora</p>
                    {(categorias && categorias.length > 0
                        ? [...categorias.map(cat => ({ cat, items: catalogo.filter(s => s.categoria === cat) })),
                           { cat: null, label: 'Sin categoría', items: catalogo.filter(s => !s.categoria || !categorias.includes(s.categoria)) }]
                          .filter(g => g.items.length > 0)
                        : [{ cat: null, items: catalogo }]
                    ).map((grupo, gi) => {
                        const todosSeleccionados = grupo.items.every(s => serviciosAsignados?.has(s.servicio));
                        const algunoSeleccionado = grupo.items.some(s => serviciosAsignados?.has(s.servicio));
                        return (
                            <div key={gi} style={{ marginBottom: 8 }}>
                                {grupo.cat && (
                                    <div onClick={() => onToggleGrupo(grupo.items, todosSeleccionados)}
                                        style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 10px', background: 'var(--pink-100)', borderRadius: 8, cursor: 'pointer', border: '0.5px solid var(--border)', marginBottom: 4 }}>
                                        <div style={{ width: 18, height: 18, borderRadius: 4, background: todosSeleccionados ? 'var(--pink-600)' : algunoSeleccionado ? 'var(--pink-200)' : '#fff', border: `1.5px solid ${todosSeleccionados ? 'var(--pink-600)' : 'var(--border)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            {todosSeleccionados && <span style={{ color: '#fff', fontSize: 11 }}>✓</span>}
                                            {algunoSeleccionado && !todosSeleccionados && <span style={{ color: 'var(--pink-600)', fontSize: 14 }}>−</span>}
                                        </div>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--pink-900)' }}>{grupo.cat}</span>
                                        <span style={{ fontSize: 11, color: 'var(--pink-800)', marginLeft: 'auto' }}>{grupo.items.filter(s => serviciosAsignados?.has(s.servicio)).length}/{grupo.items.length}</span>
                                    </div>
                                )}
                                {grupo.items.map((svc, si) => {
                                    const sel = serviciosAsignados?.has(svc.servicio);
                                    return (
                                        <div key={si} onClick={() => onToggleServicio(svc.servicio)}
                                            style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8, marginBottom: 3, cursor: 'pointer', background: sel ? 'var(--pink-50)' : '#fff', border: `0.5px solid ${sel ? 'var(--pink-400)' : 'var(--border)'}`, marginLeft: grupo.cat ? 8 : 0 }}>
                                            <div style={{ width: 18, height: 18, borderRadius: 4, background: sel ? 'var(--pink-600)' : '#fff', border: `1.5px solid ${sel ? 'var(--pink-600)' : 'var(--border)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                {sel && <span style={{ color: '#fff', fontSize: 11 }}>✓</span>}
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--pink-900)' }}>{svc.servicio}</div>
                                                <div style={{ fontSize: 11, color: 'var(--pink-800)' }}>${svc.precio}{svc.precioMaximo ? `–$${svc.precioMaximo}` : ''} · {svc.duracion} min</div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 16 }}>
                <button className="btn-outline" onClick={onCancelar}>Cancelar</button>
                <button className="btn-primary" style={{ marginTop: 0 }} onClick={onGuardar}>Guardar</button>
            </div>
        </div>
    );
};

// ── Pantalla principal ────────────────────────────────────────────────────────
export const ColaboradorasScreen = ({ onBack }) => {
    const { hashtag, ladaPais, zonaHoraria } = useSelector(state => state.auth);
    const lada = ladaPais || '521';

    const [colaboradoras, setColaboradoras] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [agregando, setAgregando] = useState(false);
    const [editandoId, setEditandoId] = useState(null);
    const [colActual, setColActual] = useState(null);
    const [catalogo, setCatalogo] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [serviciosAsignados, setServiciosAsignados] = useState(new Set());

    const colaboradoraVacia = () => ({
        nombre: '', telefono: '', idCalendar: '', esDuena: false,
        jornada: colaboradoras.length > 0
            ? jornadaADias(colaboradoras[0].jornada)
            : [...DIAS_DEFAULT],
    });

    useEffect(() => {
        cargarColaboradoras();
    }, [hashtag]);

    const cargarColaboradoras = async () => {
        setCargando(true);
        try {
            // Cargar catálogo y clasificaciones
            const catSnap = await db.doc(`general/${hashtag}/servicios/catalogo`).get();
            if (catSnap.exists) setCatalogo(catSnap.data().servicios || []);
            const empSnap = await db.doc(`general/${hashtag}`).get();
            const clStr = empSnap.data()?.clasificaciones || '';
            if (clStr) setCategorias(clStr.split(';').map(p => p.split('/')[0]));

            const snap = await db.collection(`general/${hashtag}/consultores`).get();
            const cols = snap.docs.map(doc => ({
                id: doc.id,
                nombre: doc.id.replace('@', ''),
                telefono: doc.data().telefono?.slice(-10) || '',
                idCalendar: doc.data().idCalendar || '',
                esDuena: doc.data().esDuena === true,
                activo: doc.data().activo !== false,
                jornada: jornadaADias(doc.data().jornada || []),
                noServicios: doc.data().noServicios || 0,
            }));
            setColaboradoras(cols);
        } catch (e) {
            console.log('Error:', e);
        } finally {
            setCargando(false);
        }
    };

    const handleGuardar = async () => {
        if (!colActual.nombre.trim()) { Swal.fire('Falta el nombre', 'Escribe el nombre de la colaboradora.', 'warning'); return; }
        if (colActual.telefono.length !== 10) { Swal.fire('Teléfono inválido', 'El teléfono debe tener 10 dígitos.', 'warning'); return; }
        if (!colActual.idCalendar) { Swal.fire('Falta el calendario', 'Conecta o crea un calendario de Google.', 'warning'); return; }

        const diasActivos = colActual.jornada.filter(d => d.activo);
        const jornada = diasActivos.map(d => ({
            id: d.id, entrada: d.entrada, salida: d.salida,
            ini_comida: d.tieneComida ? d.ini_comida : '00:00',
            fin_comida: d.tieneComida ? d.fin_comida : '00:00',
        }));

        const nuevoId = nameInArroba(colActual.nombre);
        const datos = {
            activo: true,
            telefono: lada + colActual.telefono,
            idCalendar: colActual.idCalendar,
            esDuena: colActual.esDuena === true,
            jornada,
            noJornadas: jornada.length,
            noServicios: colActual.noServicios || 0,
        };

        try {
            if (editandoId && editandoId !== nuevoId) {
                // Cambio de nombre — copiar doc y subcolección, eliminar anterior
                await db.doc(`general/${hashtag}/consultores/${nuevoId}`).set(datos);

                // Copiar servicios
                const listaSnap = await db.doc(`general/${hashtag}/consultores/${editandoId}/servicios/lista`).get();
                if (listaSnap.exists) {
                    await db.doc(`general/${hashtag}/consultores/${nuevoId}/servicios/lista`).set(listaSnap.data());
                }

                // Eliminar anterior
                await db.doc(`general/${hashtag}/consultores/${editandoId}`).delete();

                Swal.fire('¡Listo!', `El nombre se cambió a ${nuevoId}. Nota: si tenía citas agendadas en Google Calendar, estas no se afectan.`, 'success');
            } else {
                // Nuevo o edición sin cambio de nombre
                await db.doc(`general/${hashtag}/consultores/${nuevoId}`).set(datos, { merge: true });
            }

            // Guardar servicios asignados
            const serviciosSeleccionados = catalogo.filter(s => serviciosAsignados.has(s.servicio));
            await db.doc(`general/${hashtag}/consultores/${nuevoId}/servicios/lista`).set({ servicios: serviciosSeleccionados });
            await db.doc(`general/${hashtag}/consultores/${nuevoId}`).update({ noServicios: serviciosSeleccionados.length });

            await cargarColaboradoras();
            setAgregando(false);
            setEditandoId(null);
            setColActual(null);
            setServiciosAsignados(new Set());
            if (!editandoId) Swal.fire({ icon: 'success', title: 'Colaboradora guardada', timer: 1200, showConfirmButton: false });
        } catch (e) {
            Swal.fire('Error', 'No se pudo guardar. Intenta de nuevo.', 'error');
        }
    };

    const handleEditar = async (col) => {
        setEditandoId(col.id);
        setColActual({ ...col });
        setAgregando(false);
        // Cargar servicios asignados
        try {
            const listaSnap = await db.doc(`general/${hashtag}/consultores/${col.id}/servicios/lista`).get();
            const lista = listaSnap.exists ? (listaSnap.data().servicios || []) : [];
            setServiciosAsignados(new Set(lista.map(s => s.servicio)));
        } catch (e) {
            setServiciosAsignados(new Set());
        }
    };

    const handleToggleServicio = (nombreServicio) => {
        const nueva = new Set(serviciosAsignados);
        if (nueva.has(nombreServicio)) nueva.delete(nombreServicio);
        else nueva.add(nombreServicio);
        setServiciosAsignados(nueva);
    };

    const handleToggleGrupo = (serviciosGrupo, todosSeleccionados) => {
        const nueva = new Set(serviciosAsignados);
        serviciosGrupo.forEach(s => {
            if (todosSeleccionados) nueva.delete(s.servicio);
            else nueva.add(s.servicio);
        });
        setServiciosAsignados(nueva);
    };

    const handleToggleActivo = async (col) => {
        const accion = col.activo ? 'desactivar' : 'activar';
        const { isConfirmed } = await Swal.fire({
            title: `¿${accion.charAt(0).toUpperCase() + accion.slice(1)} a ${col.nombre}?`,
            text: col.activo ? 'No aparecerá como opción para nuevas citas.' : 'Volverá a estar disponible para reservas.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#D4537E',
            confirmButtonText: `Sí, ${accion}`,
            cancelButtonText: 'Cancelar',
        });
        if (!isConfirmed) return;
        await db.doc(`general/${hashtag}/consultores/${col.id}`).update({ activo: !col.activo });
        await cargarColaboradoras();
    };

    if (cargando) return (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: 32 }}>👩</div>
            <p style={{ color: 'var(--pink-800)' }}>Cargando...</p>
        </div>
    );

    return (
        <div className="app-container">
            <div className="app-header" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'var(--pink-600)', fontSize: 20, cursor: 'pointer', padding: '0 4px' }}>←</button>
                <div>
                    <h1>¿Quién atiende?</h1>
                    <p>{colaboradoras.filter(c => c.activo).length} activa{colaboradoras.filter(c => c.activo).length !== 1 ? 's' : ''}</p>
                </div>
            </div>

            <div className="screen-body">
                {colaboradoras.map((col, idx) => (
                    <div key={col.id}>
                        <div className="item-card" style={{ opacity: col.activo ? 1 : 0.5 }}>
                            <div style={{ width: 42, height: 42, borderRadius: '50%', background: 'var(--pink-100)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 600, color: 'var(--pink-900)', flexShrink: 0 }}>
                                {col.nombre.charAt(0).toUpperCase()}
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className="item-name">{col.nombre} {col.esDuena && <span title="Dueña">👑</span>} {!col.activo && <span style={{ fontSize: 11, color: '#999' }}>(inactiva)</span>}</div>
                                <div className="item-meta">
                                    {col.noServicios} servicio{col.noServicios !== 1 ? 's' : ''} · {col.jornada.filter(d => d.activo).length} días
                                    {col.idCalendar ? ' · 📅' : ' · Sin calendario'}
                                </div>
                            </div>
                            <button onClick={() => handleEditar(col)}
                                style={{ color: 'var(--pink-600)', background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', padding: '4px 6px' }}>✎</button>
                            <button onClick={() => handleToggleActivo(col)}
                                style={{ color: col.activo ? '#999' : 'var(--pink-600)', background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', padding: '4px 4px' }}
                                title={col.activo ? 'Desactivar' : 'Activar'}>
                                {col.activo ? '⏸' : '▶'}
                            </button>
                        </div>

                        {editandoId === col.id && colActual && (
                            <FormColaboradora
                                colaboradora={colActual}
                                onChange={setColActual}
                                onGuardar={handleGuardar}
                                onCancelar={() => { setEditandoId(null); setColActual(null); setServiciosAsignados(new Set()); }}
                                ladaPais={lada}
                                zonaHoraria={zonaHoraria}
                                hashtag={hashtag}
                                esPrimera={idx === 0}
                                catalogo={catalogo}
                                categorias={categorias}
                                serviciosAsignados={serviciosAsignados}
                                onToggleServicio={handleToggleServicio}
                                onToggleGrupo={handleToggleGrupo}
                                hayOtraDuena={colaboradoras.some(c => c.esDuena === true && c.id !== editandoId)}
                                yaConectoCalendario={colaboradoras.some(c => c.idCalendar && c.id !== editandoId)}
                            />
                        )}
                    </div>
                ))}

                {agregando && (
                    <FormColaboradora
                        colaboradora={colActual}
                        onChange={setColActual}
                        onGuardar={handleGuardar}
                        onCancelar={() => { setAgregando(false); setColActual(null); setServiciosAsignados(new Set()); }}
                        ladaPais={lada}
                        zonaHoraria={zonaHoraria}
                        hashtag={hashtag}
                        esPrimera={colaboradoras.length === 0}
                        catalogo={catalogo}
                        categorias={categorias}
                        serviciosAsignados={serviciosAsignados}
                        onToggleServicio={handleToggleServicio}
                        onToggleGrupo={handleToggleGrupo}
                        hayOtraDuena={colaboradoras.some(c => c.esDuena === true)}
                        yaConectoCalendario={colaboradoras.some(c => c.idCalendar)}
                    />
                )}

                {!agregando && !editandoId && (
                    <button className="add-btn" onClick={() => { setColActual(colaboradoraVacia()); setAgregando(true); }}>
                        + Agregar colaboradora
                    </button>
                )}
            </div>
        </div>
    );
};
